export default "{{value | translate}}";